export const toNumber = (value) => {
    return parseInt(value) || 0;
};

export const formatDateRange = (dates) => {
    if (!dates || dates.length === 0) return '';
    const start = dates[0];
    const end = dates[dates.length - 1];

    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(2);
        return `${day}/${month}/${year}`;
    };

    return `${formatDate(start)} to ${formatDate(end)}`;
};

// Name inputs: keep only letters (A-Z, a-z) and spaces.
export const sanitizeName = (value) => String(value ?? "").replace(/[^A-Za-z ]/g, "");
